import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import styled from 'styled-components';
import { DriversIcon } from '../../../../../assets/svg/Plan/MenuBar/DriversIcon';
import DriversCreateMenu from '../../../../../components/menus/DriversCreateMenu';
import { Driver } from '../../../../../domain/driver/Driver';
import Text from '../../../../../react-components/Text';
import { DriverChip } from './DriverChip';

const DriverListContainer = styled(Grid)`
  padding: 4px;
`;

export const DriversList = ({ drivers }: { drivers: Driver[] }) => {
  return (
    <DriverListContainer>
      {drivers.length === 0 && (
        <Grid container direction="column" alignItems="center" style={{ padding: `24px` }}>
          <DriversIcon style={{ width: `60px`, height: `60px` }} />
          <VSpacer small />
          <Text intlId="plans.plan.data.overview.routes.empty_placeholder.title" />
          <VSpacer small />
          <DriversCreateMenu
            id="list-routes-create-actions"
            intlId="plans.plan.data.routes.add_new"
            styleType="secondary"
          />
        </Grid>
      )}
      {drivers.map((driver) => (
        <DriverChip key={`driver-chip-${driver.id}`} driver={driver} />
      ))}
    </DriverListContainer>
  );
};
